(() => {
  const root = document.querySelector('[data-ow-social-shop]');
  if (!root) return;

  const items = [...root.querySelectorAll('[data-social-product]')];
  const search = root.querySelector('[data-social-search]');
  const count = root.querySelector('[data-social-count]');
  const empty = root.querySelector('[data-social-empty]');
  const storeSearch = root.querySelector('[data-social-store-search]');
  const browseUrl = storeSearch?.getAttribute('href');
  const filters = [...root.querySelectorAll('[data-social-filter]')];
  const heroTitle = root.querySelector('#ow-social-shop-title');
  const heroCopy = root.querySelector('.ow-social-shop__lede');
  const heroAction = root.querySelector('.ow-social-shop__skip');
  const originalHero = {
    title: heroTitle?.textContent,
    copy: heroCopy?.textContent,
    action: heroAction?.textContent,
    href: heroAction?.getAttribute('href'),
  };
  let selectedKind = 'all';

  const normalize = (value) => (value || '')
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ').trim();

  const reset = document.createElement('button');
  reset.type = 'button';
  reset.className = 'ow-social-shop__reset';
  reset.textContent = 'Clear search and filters';
  reset.hidden = true;
  count?.after(reset);

  const refresh = () => {
    const query = normalize(search?.value.trim());
    let visible = 0;
    items.forEach((item) => {
      const matchesKind = selectedKind === 'all'
        || (selectedKind === 'affordable'
          ? Number.isFinite(Number(item.dataset.socialPrice)) && Number(item.dataset.socialPrice) > 0 && Number(item.dataset.socialPrice) < 2500
          : item.dataset.socialKind === selectedKind);
      const searchable = normalize(`${item.dataset.socialTitle} ${item.dataset.socialHandle}`);
      const matchesQuery = !query || query.split(' ').every((word) => searchable.includes(word));
      const show = matchesKind && matchesQuery;
      item.hidden = !show;
      if (show) visible += 1;
    });
    if (count) count.textContent = `${visible} plant${visible === 1 ? '' : 's'} available`;
    if (empty) empty.hidden = visible !== 0;
    reset.hidden = !query && selectedKind === 'all';
    // A specific video link should lead with its plant, not the whole catalog.
    const focusedItem = query && visible === 1 && selectedKind === 'all'
      ? items.find((item) => !item.hidden) : null;
    const productLink = focusedItem?.querySelector('a[href*="/products/"]');
    if (heroTitle && heroCopy && heroAction) {
      heroTitle.textContent = productLink ? focusedItem.dataset.socialTitle : originalHero.title;
      heroCopy.textContent = productLink
        ? 'See available sizes, current pricing and delivery details for this plant.'
        : originalHero.copy;
      heroAction.textContent = productLink ? 'View plant & options' : originalHero.action;
      heroAction.setAttribute('href', productLink ? productLink.href : originalHero.href);
    }
    if (storeSearch) {
      const term = search?.value.trim();
      if (term) {
        const url = new URL(storeSearch.dataset.searchUrl, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', term);
        url.searchParams.set('options[prefix]', 'last');
        storeSearch.href = url.href;
        storeSearch.textContent = `Search all plants for “${term}”`;
      } else {
        storeSearch.setAttribute('href', browseUrl);
        storeSearch.textContent = 'Shop all plants';
      }
    }
  };

  search?.addEventListener('input', refresh);
  reset.addEventListener('click', () => {
    if (search) search.value = '';
    selectedKind = 'all';
    filters.forEach((button) => {
      const active = button.dataset.socialFilter === 'all';
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    refresh();
    search?.focus();
  });
  filters.forEach((button) => {
    button.addEventListener('click', () => {
      selectedKind = button.dataset.socialFilter || 'all';
      filters.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
      refresh();
    });
  });

  const inbound = new URLSearchParams(window.location.search);
  if (search && inbound.has('plant')) search.value = inbound.get('plant').slice(0, 120);
  const source = inbound.get('utm_source');
  if (source) {
    const medium = inbound.get('utm_medium') || 'organic_social';
    const campaign = inbound.get('utm_campaign') || 'bio_social_shop';
    items.forEach((item) => {
      const handle = item.dataset.socialHandle;
      item.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('utm_source', source);
        url.searchParams.set('utm_medium', medium);
        url.searchParams.set('utm_campaign', campaign);
        url.searchParams.set('utm_content', `seen_on_social_${handle}`);
        url.searchParams.set('utm_term', handle);
        link.href = url.toString();
      });
    });
  }

  refresh();
})();
